import TestPackageAnalyteModel from "@/models/lab/TestPackageAnalyteModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestPackageAnalyteCollection extends LabServiceCollection {
  model() {
    return TestPackageAnalyteModel;
  }

  prepareFilter(filter) {
    return filter;
  }
}
